import styled from '@emotion/styled';

import { createClassNames } from '@hrworks/design-system/functions';
import { overflowBreakWord } from '@hrworks/design-system/utilities';

import { S as ModalStyles } from '../Modal.styles';

const Header = styled.div(({ theme }) => [
  overflowBreakWord,
  {
    display: 'flex',
    height: 'min-content',
    maxHeight: 120,
    minHeight: 80,
    padding: ModalStyles.componentConfig(theme).contentPadding,
    paddingRight: 59,
    borderRadius: 0,
    borderBottom: `1px solid ${theme.eclipseTier2Color.border.bold}`,
  },
]);

const components = { Header };

export const S = {
  ...components,
  ...createClassNames('ModalHeader', components),
} as const;
